import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageStyles } from "../styles/appTheme";
export default function AppPageShell({ kicker = "Ava", title, subtitle, children, maxWidth = "1180px", }) {
    return (_jsx("div", { style: pageStyles.page, children: _jsxs("div", { style: {
                ...pageStyles.shell,
                maxWidth,
            }, children: [_jsxs("div", { style: pageStyles.topRow, children: [_jsx("div", { style: pageStyles.kicker, children: kicker }), _jsx("h1", { style: pageStyles.title, children: title }), subtitle ? _jsx("p", { style: pageStyles.subtitle, children: subtitle }) : null] }), children] }) }));
}
